<template>
  <div class="bid" v-if="isAcceptingBids">
    <span v-if="currentBid === 0 && isLoggedIn">Sin ofertas</span>
    <span v-else-if="currentBid > 0 && isLoggedIn">
      <span
        v-if="isLoggedIn && currentBidder === loggedInMembership"
        v-b-tooltip.hover.bottomleft
        title="¡ Mi oferta !"
      >
        <font-awesome-icon icon="trophy" />
      </span>
      Oferta {{ currentBid | currency }}
    </span>
    <span v-if="isEnabled" class="float-right place-bid" @click="placeBid">
      ¡Coloca oferta!
      <font-awesome-icon icon="edit" />
    </span>
  </div>
</template>

<script>
import utils from "../../assets/js/utils";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit, faTrophy } from "@fortawesome/free-solid-svg-icons";
library.add(faEdit, faTrophy);

export default {
  name: "Bid",
  props: {
    id: {
      type: String,
      default: ""
    },
    code: {
      type: String,
      default: ""
    },
    bid: {
      type: Number,
      default: 0
    },
    bidAffiliate: {
      type: Number,
      default: 0
    },
    bidStatus: {
      type: String,
      default: "off"
    }
  },
  data() {
    return {
      placedBid: 0,
      placedBidder: 0,
      dataBidStatus: null
    };
  },
  methods: {
    placeBid: async function() {
      const val = await this.$swal({
        title: "Coloca tu oferta",
        input: "text",
        html:
          "Valor en quetzales, <strong>será redondeado a la centena superior</strong>.  <br />No hace falta ingresar símbolo de moneda.<br /><br /><strong>La oferta representa un compromiso de compra.</strong>",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        inputValidator: value => {
          if (!value) {
            return "Debes colocar el valor a ofertar";
          }
          if (!utils.checkAmount(value)) {
            return "Debes colocar una cantidad válida, en quetzales.  No coloques símbolo de moneda.";
          }
          if (parseFloat(value) <= this.currentBid) {
            return (
              "El valor a ofertar debe ser mayor a " +
              utils.formatCurrency(this.currentBid)
            );
          }
        }
      });

      if (!val.value) return;

      const value = Math.ceil(val.value / 100) * 100;
      const valueString = Intl.NumberFormat("es-GT").format(value);

      const confirm = await this.$swal({
        title: "Por favor confirma tu oferta por: Q " + valueString,
        html:
          "El valor introducido pudo haber sido redondeado a la centena superior.<br /><br /><strong>La oferta representa un compromiso de compra.</strong>",
        showCancelButton: true,
        cancelButtonText: "Cancelar"
      });

      if (!confirm.value) return;

      const res = await utils.placeBid(this, this.code, value);

      if (res) {
        this.placedBid = value;
        this.placedBidder = this.loggedInMembership;
      }
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    isEnabled: function() {
      return this.$store.getters.isEnabled;
    },
    currentBid: function() {
      return this.placedBid > 0 ? this.placedBid : this.bid;
    },
    currentBidder: function() {
      return this.placedBidder > 0 ? this.placedBidder : this.bidAffiliate;
    },
    loggedInMembership: function() {
      return this.$store.getters.loggedInMembership;
    },
    isAcceptingBids: function() {
      return (
        (this.dataBidStatus ? this.dataBidStatus : this.bidStatus) === "on"
      );
    }
  },
  filters: {
    currency: function(value) {
      return utils.formatCurrency(value);
    }
  },
  created: function() {
    // Component initialization
  },
  watch: {
    id: function() {
      this.dataBidStatus = null;
    },
    // Watch for WebSocket messages from the store
    '$store.getters.socketMessage': {
      handler: function(message) {
        if (!message || !message.message || !message.message.action) {
          return;
        }
        switch (message.message.action) {
          case "bid":
            if (message.message.id !== this.id) {
              return;
            }
            this.placedBidder = message.message.code;
            this.placedBid = message.message.bid;
            break;

          case "auctionStarts":
            if (message.message.carId !== this.id) {
              return;
            }
            this.dataBidStatus = "almost";
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.bid {
  color: $red;
  font-size: 1.2rem;

  .place-bid {
    color: $black;
    font-size: 0.8rem;
    cursor: pointer;

    &:hover,
    &:focus {
      color: $redDark;
    }
  }

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 1rem;
  }
}
</style>
